import { getLocale } from "@/models/utils";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en.json";
import es from "./es.json";
import fr from "./fr.json";
import pt from "./pt.json";
import nl from "./nl.json";
import de from "./de.json";
import { AUDIO_LANGUAGES } from "@/constants";

const resources = {
  en: { translation: en },
  es: { translation: es },
  de: { translation: de },
  fr: { translation: fr },
  nl: { translation: nl },
  pt: { translation: pt },
};

const appLanguages = Object.keys(resources).map((item) =>
  AUDIO_LANGUAGES.find((lang) => lang.value === item)
);

if (!i18n.isInitialized && typeof window === "object") {
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get("lang");
  let deviceLang = localStorage.getItem("locale") || getLocale();
  if (lang) {
    deviceLang = lang.slice(0, 2);
    localStorage.setItem("locale", deviceLang);
  }

  i18n.use(initReactI18next).init({
    resources,
    lng: deviceLang,
    fallbackLng: "en",
    compatibilityJSON: "v4",
    interpolation: {
      escapeValue: false,
    },
  });
}

export { i18n, appLanguages };
